import { css, CSSResult } from 'lit'
import {
  csColorAction,
  csColorBackground
} from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csBorder, csTransition } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const cseAutoplayButton = {
  size: css`var(--cse-autoplay-button-size, 42px)`,
  ringStrokeWidth: css`var(--cse-autoplay-button-ring-stroke-width, 3px)`,

  backgroundColor: css`var(--cse-autoplay-button-background-color, transparent)`,
  backgroundColorHover: css`var(--cse-autoplay-button-background-color-hover, transparent)`,

  color: css`var(--cse-autoplay-button-color, ${csColorAction.linkSecondary})`,
  colorHover: css`var(--cse-autoplay-button-color-hover, ${csColorAction.linkSecondaryHover})`,

  borderRadius: css`var(--cse-autoplay-button-border-radius, ${csBorder.radiusFull})`,

  ringBackgroundColor: css`var(--cse-autoplay-button-ring-background-color, ${csColorBackground.secondary})`,
  ringForegroundColor: css`var(--cse-autoplay-button-ring-foreground-color, ${csColorAction.secondary})`,


}

export const style: CSSResult = css`
  :host {
    display: inline-flex;
  }

  .cse-autoplay-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${cseAutoplayButton.size};
    height: ${cseAutoplayButton.size};
    border: 0;
    border-radius: ${cseAutoplayButton.borderRadius};
    background-color: ${cseAutoplayButton.backgroundColor};
    color: ${cseAutoplayButton.color};
    transition-duration: ${csTransition.duration};
    transition-property: color, background-color;
    transition-timing-function: ${csTransition.timingFunction};
    cursor: pointer;
  }

  .cse-autoplay-button:hover {
    background-color: ${cseAutoplayButton.backgroundColorHover};
    color: ${cseAutoplayButton.colorHover};
  }

  .progress-ring {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
  }

  .ring-background,
  .ring-foreground {
    stroke-width: ${cseAutoplayButton.ringStrokeWidth};
  }

  .ring-background {
    stroke: ${cseAutoplayButton.ringBackgroundColor};
  }

  .ring-foreground {
    stroke: ${cseAutoplayButton.ringForegroundColor};
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }

  .icon {
    position: relative;
    z-index: 1;
  }
`
